angular.module('impactx.basket').controller('BasketTypeIconCtrl', BasketTypeIconCtrl);

function BasketTypeIconCtrl()
{
    this.getBasketTypeIcon = function (statusValue)
    {
        switch (statusValue)
        {
            // user template
            case 50:
                return "mdi mdi-24px mdi-account";
            // company template
            case 51:
                return "mdi mdi-24px mdi-domain";
            // system template
            case 52:
                return "mdi mdi-24px mdi-server";
            // disposition template
            case 55:
                return "mdi mdi-24px mdi-basket";
            // default
            default:
                return "mdi mdi-24px mdi-basket"
        }
    };
}